import { render, staticRenderFns } from "./SignInPatientButton.vue?vue&type=template&id=04218804&scoped=true"
import script from "./SignInPatientButton.vue?vue&type=script&lang=js"
export * from "./SignInPatientButton.vue?vue&type=script&lang=js"
import style0 from "./SignInPatientButton.vue?vue&type=style&index=0&id=04218804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04218804",
  null
  
)

export default component.exports